// https://react-select.com/home
import React, {useState, useEffect} from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';


const CreatableSelectAutocomplete = (props) => {
  let [selectedOption, setSelectedOption] = useState(null);
  useEffect(function () {
    const initial = props.options.find( i => i.value === props.input.value);
    if (initial){
      setSelectedOption(initial);
      props.input.onChange(initial);
    }
  }, [props.options])

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption);
    props.input.onChange(selectedOption);
  };

  const handleBlur = () => {
    props.input.onBlur(selectedOption);
  }

  const formatCreateLabel = inputValue => {
    return gettext('Добавить') + ' "' + inputValue + '"';
  }

  const { input, meta, label, helptext, placeholder, required, options } = props;
  let validate_class = '';
  if (meta.touched){
    meta.error ? validate_class = ' is-invalid' : validate_class = ' is-valid';
  }

  return <Form.Group controlId={ name + '_id' } bsPrefix={'form-group' + validate_class}>
    { label ? <Form.Label>{ label }{ required ? ' *' : '' }</Form.Label> : '' }
    <CreatableSelect
      value={ selectedOption }
      onChange={ handleChange }
      isSearchable={ true }
      isClearable={ true }
      options={ options }
      placeholder={ placeholder }
      formatCreateLabel={ formatCreateLabel }
      createOptionPosition='first'
      onFocus={ input.onFocus }
      onBlur={ handleBlur }
      noOptionsMessage={ gettext('Ничего не найдено') }
    />
    { helptext ? <Form.Text className="text-muted">{ helptext }</Form.Text> : '' }
    { (meta.touched && meta.error) && <Form.Control.Feedback type="invalid">{ meta.error }</Form.Control.Feedback> }
    </Form.Group>

}

let mapStateToProps = (state) => {
  return {

  }
};

export default compose(
  connect(mapStateToProps, { }),
)(CreatableSelectAutocomplete);

